import { BackwardIcon, ForwardIcon, PauseIcon, PlayIcon } from '@heroicons/react/24/solid';
import { Audio } from '@sina_byn/re-audio';
import { useEffect, useState } from 'react';

const CustomAudioPlayer = ({ audioSrc, className }) => {
  return (
    <div className={`p-4 border border-neutral-200 rounded-lg shadow-md bg-white ${className}`}>
      <Audio playlist={[{ id: 1, src: audioSrc, name: 'Custom Audio' }]}>
        {({ currentTime, duration, setCurrentTime, playing, togglePlay, rewindTrack, forwardTrack }) => {
          return (
            <div className='flex items-center gap-4'>
              <BackwardIcon className='h-6 w-6 cursor-pointer text-hb-orange' onClick={() => rewindTrack(10)} />
              {playing ? (
                <PauseIcon className='h-6 w-6 cursor-pointer text-hb-orange' onClick={togglePlay} />
              ) : (
                <PlayIcon className='h-6 w-6 cursor-pointer text-hb-orange' onClick={togglePlay} />
              )}
              <ForwardIcon className='h-6 w-6 cursor-pointer text-hb-orange' onClick={() => forwardTrack(10)} />
              <div className='flex-grow'>
                <input
                  type='range'
                  min='0'
                  max={duration || 0}
                  value={currentTime}
                  onChange={(e) => setCurrentTime(Number.parseFloat(e.target.value))}
                  className='w-full accent-hb-orange'
                />
              </div>
              <span className='font-robotoCondensed text-sm text-neutral-800 font-medium'>
                {Math.floor(currentTime / 60)}:
                {Math.floor(currentTime % 60)
                  .toString()
                  .padStart(2, '0')}
              </span>
            </div>
          );
        }}
      </Audio>
    </div>
  );
};

export default CustomAudioPlayer;
